<template>
  <a
    class="text-base md:text-sm lg:text-base text-white cursor-pointer hover:text-[#5e9822] transition-all h-full flex items-center"
  >
    <slot />
  </a>
</template>
<script setup lang="ts">
</script>
